
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue";
import { AssessmentQuestion } from "@/interfaces/recruiter/candidates/create_assessment";
import { mapMutations } from "vuex";
import { ROOT_ERROR } from "@/store/modules/root/constants";

export default Vue.extend({
  name: "QuestionModal",
  data() {
    return {
      isValid: true,
      saving: false,
      localQuestion: {
        question_text: "",
        question_type: "mcq",
        question_options: [""],
        is_question_enable: true,
        order: 0,
        question_time_allowed: 60,
        correct_answer: ""
      } as AssessmentQuestion,
      rules: {
        required: (v: string) => !!v || "This field is required",
        positive: (v: number) => v > 0 || "Must be greater than 0"
      }
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object as () => AssessmentQuestion,
      default: () => ({})
    },
    questionTypes: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        if (newQuestion && Object.keys(newQuestion).length > 0) {
          const questionOptions = Array.isArray(newQuestion.question_options)
            ? [...newQuestion.question_options].slice(0, 4)
            : [];

          this.localQuestion = {
            ...this.localQuestion,
            question_text: newQuestion.question_text || "",
            question_type: newQuestion.question_type || "mcq",
            question_time_allowed: newQuestion.question_time_allowed || 60,
            correct_answer: newQuestion.correct_answer || "",
            question_options: questionOptions,
            is_question_enable:
              newQuestion.is_question_enable !== undefined
                ? newQuestion.is_question_enable
                : true
          };
        } else {
          this.resetForm();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      set_root_error: ROOT_ERROR
    }),
    resetForm() {
      this.localQuestion = {
        question_text: "",
        question_type: "mcq",
        question_options: [],
        is_question_enable: true
      };
    },
    onQuestionTypeChange() {
      // Reset options based on question type
      if (this.localQuestion.question_type === "mcq") {
        this.localQuestion.question_options = ["", ""];
      } else if (this.localQuestion.question_type === "true_false") {
        this.localQuestion.question_options = [];
      } else {
        this.localQuestion.question_options = [];
      }
    },
    isArabic() {
      return localStorage.getItem("locale") === "ar";
    },
    addOption() {
      if (this.localQuestion.question_options.length < 4) {
        this.localQuestion.question_options.push("");
      }
    },

    async saveQuestion() {
      if (!this.isValid) return;

      this.saving = true;
      try {
        // Validate options for multiple choice
        if (this.localQuestion.question_type === "mcq") {
          const validOptions = this.localQuestion.question_options.filter(
            (opt: string) => opt.trim() !== ""
          );

          if (validOptions.length < 2) {
            // Use localized message for MCQ validation
            this.set_root_error(
              this.$t("candidate.assessments.create.mcq-min-options")
            );
            return;
          }
        }

        const questionData = {
          ...this.localQuestion,
          question_type: this.localQuestion.question_type,
          question_text: this.localQuestion.question_text,
          is_question_enable: this.localQuestion.is_question_enable,
          question_options:
            this.localQuestion.question_type === "mcq"
              ? this.localQuestion.question_options
              : [],
          order: this.localQuestion?.order
        };

        this.$emit("save", questionData);
      } catch (error) {
        console.error("Error saving question:", error);
        this.set_root_error(
          this.$t("candidate.assessments.create.question-save-error")
        );
      } finally {
        this.saving = false;
      }
    }
  }
});
